import React from 'react';
import { Drawer } from 'vaul';
import { CloseXComponent as CloseXIcon } from 'ui/Icons';

interface ISalesMetricsFiltersDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const SalesMetricsFiltersDrawer: React.FC<ISalesMetricsFiltersDrawerProps> = ({ isOpen, onClose, children }) => {
  return (
    <Drawer.Root direction="left" open={isOpen} onOpenChange={onClose} dismissible={true}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/70 z-[99998]" />
        <Drawer.Content className="h-[100dvh] bg-white p-[20px] w-[80%] max-w-[380px] fixed top-0 left-0 outline-none z-[99999]">
          <div className="relative flex flex-col h-full">
            <span className="font-pt-sans font-bold text-[17px] text-text-colour">Filter Results</span>

            <button onClick={onClose} className="absolute top-0 right-0 bg-transparent outline-none cursor-pointer p-0">
              <CloseXIcon />
            </button>

            <div className="flex-1 overflow-y-auto mt-20px">{children}</div>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};
